import "./App.css";
import "@fontsource/work-sans";
import "./styles/global.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastProvider } from "../src/Utils/toastContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginPage from "./Pages/Login/login";
import AdminSignup from "./Pages/Admin-signup/Admin-signup";
import AdminLogin from "./Pages/Admin-login/Admin-login";
import AdminDashboard from "./Pages/Admin-Dashboard/Admin-Dashboard";
import CreateInvestment from "./Pages/Create-Investment/Create-Investment";
import TableWithFilters from "./Components/TableWithFilters/tableWithFilters";
import InvestmentRequestList from "./Pages/Investment-Request-List/Investment-Request-List";
import InvestmentProductDetails from "./Pages/InvestmentProductDetails/investment-product-details";
import DashboardDetails from "./Pages/Dashboard-Details/Dashboard-Details";
import InvestmentDetails from "./Pages/Dashboard-Details/Investment-Details";
import ForgotPassword from "./Pages/Admin-login/Forgot-Password";
import CustomerList from "./Pages/Customer/customer-list";
import AdvisorList from "./Pages/Advisor/advisor-list";
import SubAdvisorList from "./Pages/Advisor/sub-advisor-list";
import AdvisorDetails from "./Pages/Advisor/advisor-detail";
import SubAdvisorDetails from "./Pages/Advisor/sub-advisor-details";
import CustomerDetails from "./Pages/Customer/customer-detail";
import Rebalancing from "./Pages/Rebalancing/rebalancing";
import StockList from "./Pages/StockList/stock-list";
import ReviewKyc from "./Pages/Customer/review-kyc";
import ReviewKycJointAccount from "./Pages/Customer/review-kyc-joint-account";
import ReviewKYCTrust from "./Pages/Customer/review-kyc-trust";
import ReviewKycShareholderTrust from "./Pages/Customer/review-kyc-shareholder-trust";

import ReviewKYCCorporate from "./Pages/Customer/review-kyc-corporate";
import ReviewKycShareholder from "./Pages/Customer/review-kyc-shareholder";
import InvestmentDetailsByID from "./Components/TableWithFilters/investment-detail";
import ViewHistory from "./Components/TableWithFilters/view-history";
import ProductSettings from "./Pages/Product-Settings/product-settings";
import RolesPermissionSettings from "./Pages/Product-Settings/role-permissions-settings";
import ProductApproval from "./Pages/Product-Approval/product-approval";
import InvestorList from "./Pages/Investor-List/investor-list";
import InvestorListTransaction from "./Pages/Investor-List/investor-transaction-list";
import InspecieTransferRequest from "./Pages/Inspecie-Transfer/inspecie-transfer";
import StrategyDetails from "./Pages/Inspecie-Transfer/strategy-detail";
import SuggestedStrategies from "./Pages/Inspecie-Transfer/suggested-strategies";
import InDepthStrategyDetails from "./Pages/Inspecie-Transfer/in-depth-strategy-details";
import UnAllocatedStocks from "./Pages/Unallocated-Stocks/unallocated-stocks";
import InvestmentDetailsByCustomerID from "./Components/TableWithFilters/investment-detail-customer";
import MyProfile from "./Pages/Dashboard-Details/my-profile";
import MandateDetails from "./Pages/Dashboard-Details/mandate-details";
import { initVersionCheck, stopVersionCheck } from "./Utils/versionManager";
import MultiStepSidebarForm from "./Pages/Onboarding/multi-step-sidebar-form";
import { useSelector, useDispatch } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("jwtToken");
  return token ? children : <Navigate to="/login" />;
};

function App() {
  const roleName = useSelector((state) => state.user.roleName);

  useEffect(() => {
    initVersionCheck();

    return () => {
      stopVersionCheck();
    };
  }, []);
  useEffect(() => {
    const checkIndexCache = async () => {
      try {
        // Fetch index.html directly from server
        const response = await fetch("/index.html", {
          method: "GET",
          cache: "no-store", // ensure we get latest
        });

        console.log("--- index.html headers ---");
        console.log("Status:", response.status);
        console.log("Cache-Control:", response.headers.get("Cache-Control"));
        console.log("Pragma:", response.headers.get("Pragma"));
        console.log("Expires:", response.headers.get("Expires"));

        if (
          response.headers.get("Cache-Control")?.includes("no-cache") ||
          response.headers.get("Cache-Control")?.includes("no-store")
        ) {
          console.log("✅ index.html is not cached");
        } else {
          console.warn("⚠️ index.html might be cached! Users may see old UI");
        }
      } catch (err) {
        console.error("Error fetching index.html:", err);
      }
    };

    checkIndexCache();
  }, []);
  return (
    <ToastProvider>
      <BrowserRouter>
        <ToastContainer />

        <Routes>
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/sign-up" element={<AdminSignup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/customer-login" element={<LoginPage />} />

          <Route
            path="/investment-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <TableWithFilters />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/unallocated-account-details"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <UnAllocatedStocks />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-approval"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ProductApproval />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-investment"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CreateInvestment />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/in-depth-strategy-details"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InDepthStrategyDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investment-details-customer/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentDetailsByCustomerID />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CustomerList componentName="customer" />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AdvisorList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sub-advisor-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <SubAdvisorList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-details/:customerId/:customerPrevId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <CustomerDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor-details/:customerId/:customerPrevId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <AdvisorDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/sub-advisor-details/:customerId/:customerPrevId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <SubAdvisorDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path={roleName == "team" ? "/" : "/my-profile"}
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MyProfile />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investor-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestorList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investor-list-transactions"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestorListTransaction />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/inspecie-transfer-request"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InspecieTransferRequest />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investment-request-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentRequestList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/strategy-details"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <StrategyDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/suggested-strategies"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <SuggestedStrategies />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock-list"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <StockList />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/rebalancing"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <Rebalancing />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/view-history"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ViewHistory />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mandate-payment-history/:mandateId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MandateDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investment-product-details"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentProductDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-settings"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ProductSettings />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/roles-permissions"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <RolesPermissionSettings />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path={roleName != "team" ? "/" : "/admin"}
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <DashboardDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investment-details"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentDetails />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/investment-details-by-id"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <InvestmentDetailsByID />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKyc />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <MultiStepSidebarForm />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-jointaccount/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycJointAccount />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-corporate/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKYCCorporate />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-trust/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKYCTrust />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-kyc-corporate-shareholder/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycShareholder />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
                    <Route
            path="/review-kyc-trust-shareholder/:customerId"
            element={
              <ProtectedRoute>
                <AdminDashboard>
                  <ReviewKycShareholderTrust />
                </AdminDashboard>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
